import './app.css';
import AppLoading from './components/AppLoading';

function App() {
  return <AppLoading />;
}

export default App;
